const toneClass = {
  green: "bg-green/10 text-green",
  pink: "bg-pink/10 text-pink",
  neutral: "bg-navy/5 text-navy/70",
};

function ChangePill({ change, tone }) {
  if (!change) return null;
  return (
    <span className={`inline-block rounded-full px-3 py-1 text-xs font-bold ${toneClass[tone] || toneClass.neutral}`}>
      {change}
    </span>
  );
}

export function SnapshotTable({ snapshot, testId }) {
  return (
    <div data-testid={testId} className="rounded-xl border border-mist bg-white p-6 md:p-8">
      <h3 className="text-xl font-bold text-navy md:text-2xl">{snapshot.caption}</h3>
      {snapshot.intro && <p className="mt-2 max-w-2xl text-sm text-navy/70">{snapshot.intro}</p>}

      <table className="mt-6 hidden w-full text-left md:table">
        <thead>
          <tr className="border-b border-mist text-xs font-bold uppercase tracking-widest text-navy/50">
            <th className="pb-3 pr-4">Metric</th>
            <th className="pb-3 pr-4">Before</th>
            <th className="pb-3 pr-4">With us</th>
            <th className="pb-3">Change</th>
          </tr>
        </thead>
        <tbody>
          {snapshot.rows.map((r) => (
            <tr key={r.metric} className="border-b border-mist/60 last:border-0">
              <td className="py-4 pr-4 text-sm font-bold text-navy">{r.metric}</td>
              <td className="py-4 pr-4 text-base text-navy/60">{r.before}</td>
              <td className="py-4 pr-4 text-lg font-extrabold text-navy">{r.after}</td>
              <td className="py-4"><ChangePill change={r.change} tone={r.tone} /></td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="mt-6 space-y-3 md:hidden">
        {snapshot.rows.map((r) => (
          <div key={r.metric} className="rounded-lg bg-fog p-4" data-testid={testId ? `${testId}-row-${r.metric.toLowerCase().replace(/[^a-z0-9]+/g, "-")}` : undefined}>
            <div className="flex items-center justify-between">
              <span className="text-xs font-bold uppercase tracking-widest text-navy/50">{r.metric}</span>
              <ChangePill change={r.change} tone={r.tone} />
            </div>
            <div className="mt-2 flex items-baseline gap-3">
              <span className="text-sm text-navy/50 line-through decoration-navy/30">{r.before}</span>
              <span className="text-xl font-extrabold text-navy">{r.after}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
